/**
 * ? @description : Create Group Component
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

// Components
import CreateGroup from "./create_batches_modal/CreateGroup";
import Axios from "../../../../../axios/Axios";
import { setTemplate } from "../../../../redux/features/templateSlice";
import { showSnackbar } from "../../../../redux/features/appSlice";
import { useDispatch } from "react-redux";
import axios from "axios";


function CreateBatchesModal(props) {

  const dispatch = useDispatch();
  const [ mailTemplate, setMailTemplate] = useState("Loading...")
// console.log(mailTemplate);
  useEffect(()=>{
    const controller = axios.CancelToken.source();
   
    const fetchData = async () =>{
    const options ={
      method: "get",
      url:"batches/get/mail/template",
      auth: true,
      data: null,
      token:{cancelToken: controller.token}
    }
     try {
      const getTemplates = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data,
        options.token,
        )
      if (getTemplates.status === 200){
        // console.log(getTemplates.data[0].message);
        setMailTemplate(getTemplates.data[0].message)
      }
     } catch(err){
      if(!axios.isCancel(err)) {
        console.log(err);
        dispatch(
          showSnackbar({ message: "Error fetching templates", severity: "error" })
        );
      }
     
     }
   }
 fetchData();
 return () => {
  controller.cancel();
}
  },[props.show])

  return (
    <Modal
      {...props}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Create Batch
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <CreateGroup mailTemplate={mailTemplate} props={props} />
      </Modal.Body>

      {/* <Modal.Footer>
        <Button type="button" variant="primary" onClick={props.onHide}>
          Close
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default CreateBatchesModal;
